import { Maybe } from 'src/generated/webapp_gql';
import { contentLinkNodeNavigateTo } from 'src/modules/dashboard/helpers/contentLinkNodeNavigateTo';
import { SectionHeaderProps } from 'src/shared/ds';
import { ScreenLinkFragment } from 'src/modules/dashboard/documents/getHomeScreen.generated';

export const mapContentLinkToSectionHeaderProps = (
    link?: Maybe<ScreenLinkFragment>,
): Pick<SectionHeaderProps, 'secondaryText' | 'onSecondaryTextPress'> => {
    if (!link) {
        return {
            secondaryText: undefined,
            onSecondaryTextPress: undefined,
        };
    }
    switch (link.__typename) {
        case 'InternalLinkNode':
            return {
                secondaryText: link.title,
                onSecondaryTextPress: contentLinkNodeNavigateTo(link),
            };
        default:
            return {
                secondaryText: undefined,
                onSecondaryTextPress: undefined,
            };
    }
};
